import { Card, Col, Descriptions, Flex, Tag } from 'antd'
import type { DescriptionsItemType } from 'antd/es/descriptions'
import dayjs from 'dayjs'

import { SubscriptionStatus } from '@components/SubscriptionStatus'
import { PencilSimpleIcon } from '@phosphor-icons/react'

import type { Subscription } from '../../../../types'

interface SubscriptionCardsProps {
    subscription: Subscription
    onEditSubscription: (subscription: Subscription) => void
}

export const SubscriptionCard = ({ subscription, onEditSubscription }: SubscriptionCardsProps) => {
    const productKeys = subscription?.subscriptionProducts?.map(sp => sp.product.key).join(', ')
    const name = subscription?.name ? subscription.name : productKeys

    const subscriptionDetails: DescriptionsItemType[] = [
        {
            label: 'Status',
            children: <SubscriptionStatus status={subscription.status} />
        },
        {
            label: 'Term',
            children: <Tag>{subscription.term}</Tag>
        },
        {
            label: 'Products',
            children: (
                <Flex gap="small" wrap>
                    {subscription?.subscriptionProducts?.map(sp => (
                        <Tag key={sp.product.key}>{sp.product.key}</Tag>
                    ))}
                </Flex>
            )
        },
        {
            label: 'Starts on',
            children: subscription?.startDate ? dayjs(subscription.startDate).format('YYYY-MM-DD HH:mm:ss') : 'N/A'
        },
        {
            label: 'Ends on',
            children: subscription?.endDate ? dayjs(subscription.endDate).format('YYYY-MM-DD HH:mm:ss') : 'N/A'
        }
    ]

    if (subscription.stripeId) {
        subscriptionDetails.push({
            label: 'Stripe ID',
            children: (
                <a
                    href={`https://dashboard.stripe.com/${import.meta.env.VITE_STRIPE_ACCOUNT}/test/subscriptions/${
                        subscription.stripeId
                    }`}
                    target="_blank"
                >
                    {subscription.stripeId}
                </a>
            )
        })
    }

    return (
        <Col key={subscription.id}>
            <Card
                title={name}
                style={{ width: 300 }}
                actions={[<PencilSimpleIcon key="edit" onClick={() => onEditSubscription(subscription)} />]}
            >
                <Descriptions items={subscriptionDetails} column={1} />
            </Card>
        </Col>
    )
}
